import * as React from 'react';
import { observer } from 'mobx-react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import TinyInput from '@src/components/tiny-input';
import $$tracker from '@src/tracker';
import ReservationModalStore from './store';

const styles = require('./index.less');
const PHONE_SETTING_URL = 'https://security.xoyo.com/phone-setting';

const HiddenText = ({ children }) => <span className={styles.visuallyHidden}>{children}</span>;

const VerificationContent = observer(({ store }) => (
  <React.Fragment>
    <div className={styles.form}>
      <TinyInput store={store.idNumberInputStore} maxLength={18} placeholder="请输入身份证号码" aria-label="身份证" />
      <input className={styles.phoneInput} value={store.phoneDisplay} disabled aria-label="绑定手机" />
      <TinyInput store={store.codeInputStore} className={styles.codeInput} maxLength={6} placeholder="请输入验证码" aria-label="验证码" />
      <button className={styles.codeButton} type="button" disabled={store.isSendingCode || store.countdown > 0} onClick={() => store.requestCode()}>
        {store.countdown > 0 ? `${store.countdown}秒` : store.isSendingCode ? '发送中' : '获取验证码'}
      </button>
    </div>
    <button className={styles.confirm} type="button" disabled={store.isSubmitting} onClick={() => store.submitReservation()}>
      <HiddenText>{store.isSubmitting ? '验证中' : '验证'}</HiddenText>
    </button>
  </React.Fragment>
));

const PhoneBindingContent = ({ store }) => (
  <React.Fragment>
    <a
      className={styles.bindPhone}
      href={PHONE_SETTING_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => $$tracker.clickBindPhone()}
      aria-label="去绑定手机"
    >
      <HiddenText>去绑定手机</HiddenText>
    </a>
    <button
      className={styles.boundPhone}
      type="button"
      onClick={() => {
        $$tracker.clickHaveBindPhone();
        store.onClickClose();
      }}
      aria-label="我已绑定手机"
    />
  </React.Fragment>
);

export const SuccessContent = ({ store }) => (
  <React.Fragment>
    <p className={styles.successMessage}>
      账号<span>{window.__JXSJ_RESERVATION_CONFIG__.account || store.account || '当前账号'}</span>已成功预约生态服【<span>
        {window.__JXSJ_RESERVATION_CONFIG__.server_name || store.serverName}
      </span>】
      {window.__JXSJ_ACTIVATE_RESULT__ &&
        window.__JXSJ_ACTIVATE_RESULT__.friends?.length > 0 && (
          <React.Fragment>
            您的好友<span>{window.__JXSJ_ACTIVATE_RESULT__.friends.join('、')}</span>等多位好友也成功参与新服预约。
          </React.Fragment>
        )}
    </p>
    <button className={styles.successConfirm} type="button" onClick={store.onClickClose} aria-label="确定" />
  </React.Fragment>
);

const ReservationModal = ({ store, onClose }) => {
  store.use();
  store.onClose = onClose;
  return (
    <ModalContainer modalState={store.isOpen}>
      <section className={`${styles.panel} ${styles[store.mode]}`} aria-label={store.title}>
        <button className={styles.close} type="button" aria-label="关闭" onClick={store.onClickClose} />
        {store.mode === 'verification' && <VerificationContent store={store} />}
        {store.mode === 'phoneBinding' && <PhoneBindingContent store={store} />}
        {store.mode === 'success' && <SuccessContent store={store} />}
      </section>
    </ModalContainer>
  );
};

export { ReservationModalStore };
export default wrapStore(ReservationModal, ReservationModalStore);
